import {
  getDownloadInfoFetch,
  getSpeedTestResultInfoFetch,
} from "../../services/result";

const SAVE_DATA = "SAVE_DATA";
const SAVE_DONWLOAD_INFO = "SAVE_DOWNLOAD_INFO";

function saveData(data) {
  return {
    payload: data,
    type: SAVE_DATA,
  };
}

function saveDownloadInfo(data) {
  return {
    payload: data,
    type: SAVE_DONWLOAD_INFO,
  };
}

function getDownloadInfo(params) {
  console.log("params: ", params);
  const { payload, callback } = params;
  return async (dispatch) => {
    const res = await getDownloadInfoFetch(payload);
    if (res && res.iRet === 0) {
      callback && callback(res.data);
      dispatch(saveDownloadInfo(res.data));
    }
  };
}

function getSpeedTestResultInfo(params) {
  const { payload, callback } = params;
  return async (dispatch) => {
    const res = await getSpeedTestResultInfoFetch(payload);
    if (res && res.iRet === 0) {
      const { data } = res;
      callback && callback(data);
      dispatch(saveData({ speedTestResultInfo: data }));
    }
  };
}

const actions = {
  getDownloadInfo,
  getSpeedTestResultInfo,
};

const constants = {
  SAVE_DATA,
  SAVE_DONWLOAD_INFO,
};

export { actions, constants };
